import { Button } from "atoms/button/Button";
import { TextField } from "atoms/text-field/TextField";

import { QuizStepProps } from "../useQuestionnaire";

export const CurrentWeight = (props: QuizStepProps) => {
  const hasError = !!props.errors?.CurrentWeight;

  return (
    <div className="flex h-full flex-col">
      <div className="pb-8 font-serif text-h3">
        What is your current weight in pounds (lbs)?
      </div>
      <div>
        <TextField
          label="Weight (lbs)"
          type="number"
          invalid={hasError}
          value={props.data.CurrentWeight as string}
          onChange={(value) => props.handleStepData("CurrentWeight", value)}
        />
      </div>
      {hasError && (
        <p className="pt-2 text-sm text-red">{props.errors?.CurrentWeight}</p>
      )}
      <div className="mt-auto">
        <Button fullWidth onClick={props.next}>
          Next Question
        </Button>
      </div>
    </div>
  );
};
